import { useState, useCallback } from 'react';
import translations from '../i18n/translations.js';

export function useLang() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('arbauto_lang');
    if (saved && translations[saved]) return saved;
    const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
    if (browserLang === 'fr') return 'fr';
    if (browserLang === 'pt') return 'pt';
    if (browserLang === 'es') return 'es';
    return 'en';
  });

  const t = useCallback((key, vars) => {
    const str = (translations[lang] && translations[lang][key]) || translations.en[key] || key;
    if (!vars) return str;
    return Object.entries(vars).reduce((s, [k, v]) => s.replace(new RegExp(`\\{${k}\\}`, 'g'), v), str);
  }, [lang]);

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('arbauto_lang', newLang);
  };

  return { lang, changeLang, t };
}
